export default {
    name: "Bitcoin SV",
    coin: "BSV",
    scheme: "SOLO",
    account: '1ACsP6RgahG2bmw9xyksqnBw8VszNQGqYA',
    explorer_url: 'https://bitails.io',
    coingecko: 'https://www.coingecko.com/en/coins/bitcoin-sv',
    explorer: {
        address: "https://bitails.io/address/",
        height: "https://bitails.io/block-height/",
        hash: "https://bitails.io/block/",
        tx: "https://bitails.io/tx/",
    },
    ports: [
        {
            info: "LOW",
            host: "molepool.com",
            port: 1201,
            diff: 65536,
        },
        {
            info: "MID",
            host: "molepool.com",
            port: 1202,
            diff: 524288,
        }
    ]
};
